import { get, identity } from 'lodash';
import { getLayoutName, LAYOUT_CARD_MEDIUM, LAYOUT_SIDE_BY_SIDE, LAYOUT_TEXT_ON_IMAGE_MEDIUM, LAYOUT_GRID, LAYOUT_CARD_SMALL, LAYOUT_TEXT_ON_IMAGE_SMALL, LAYOUT_CARD_LARGE, LAYOUT_FULL_POST, LAYOUT_ONE_COLUMN_MOBILE, LAYOUT_SIDE_BY_SIDE_MOBILE, LAYOUT_TEXT_ON_IMAGE_MOBILE, LAYOUT_PG_TEXT_ON_IMAGE_SMALL, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_TEXT_ON_IMAGE_LARGE, LAYOUT_PG_CARD_MEDIUM, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_SIDE_BY_SIDE_RIGHT, LAYOUT_PG_GRID, LAYOUT_PG_GRID_INTERMEDIATE, LAYOUT_PG_GRID_LARGE, LAYOUT_PG_ONE_COLUMN, LAYOUT_LIST, LAYOUT_LIST_MEDIUM, LAYOUT_LIST_LARGE, LAYOUT_SLIDER, } from './layout-types';
import { SECTION_HOMEPAGE, SECTION_MY_POSTS } from './sections';
// Mobile
export const IS_MOBILE_DISPLAY_SETTINGS_ENABLED = 'blog-mobile-isMobileDisplaySettingsEnabled';
export const IS_MOBILE_DISPLAY_SETTINGS_ENABLED_PATH = `style.booleans.${IS_MOBILE_DISPLAY_SETTINGS_ENABLED}`;
export const IS_VIEW_COUNT_ENABLED_MOBILE = 'blog-mobile-isViewCountEnabled';
export const IS_VIEW_COUNT_ENABLED_MOBILE_PATH = `style.booleans.${IS_VIEW_COUNT_ENABLED_MOBILE}`;
export const IS_MORE_OPTIONS_MENU_ENABLED_MOBILE = 'blog-mobile-isMoreOptionsMenuEnabled';
export const IS_MORE_OPTIONS_MENU_ENABLED_MOBILE_PATH = `style.booleans.${IS_MORE_OPTIONS_MENU_ENABLED_MOBILE}`;
export const IS_COMMENT_COUNT_ENABLED_MOBILE = 'blog-mobile-isCommentCountEnabled';
export const IS_COMMENT_COUNT_ENABLED_MOBILE_PATH = `style.booleans.${IS_COMMENT_COUNT_ENABLED_MOBILE}`;
export const IS_LIKE_COUNT_ENABLED_MOBILE = 'blog-mobile-isLikeCountEnabled';
export const IS_LIKE_COUNT_ENABLED_MOBILE_PATH = `style.booleans.${IS_LIKE_COUNT_ENABLED_MOBILE}`;
export const IS_AUTHOR_NAME_ENABLED_MOBILE = 'blog-mobile-isAuthorNameEnabled';
export const IS_AUTHOR_NAME_ENABLED_MOBILE_PATH = `style.booleans.${IS_AUTHOR_NAME_ENABLED_MOBILE}`;
export const IS_AUTHOR_PICTURE_ENABLED_MOBILE = 'blog-mobile-isAuthorPictureEnabled';
export const IS_AUTHOR_PICTURE_ENABLED_MOBILE_PATH = `style.booleans.${IS_AUTHOR_PICTURE_ENABLED_MOBILE}`;
export const IS_AUTHOR_BADGE_ENABLED_MOBILE = 'blog-mobile-isAuthorBadgeEnabled';
export const IS_AUTHOR_BADGE_ENABLED_MOBILE_PATH = `style.booleans.${IS_AUTHOR_BADGE_ENABLED_MOBILE}`;
export const AUTHOR_INFO_TYPE_MOBILE = 'blog-mobile-authorInfoType';
export const AUTHOR_INFO_TYPE_MOBILE_PATH = `style.numbers.${AUTHOR_INFO_TYPE_MOBILE}`;
export const IS_POST_DATE_ENABLED_MOBILE = 'blog-mobile-isPostDateEnabled';
export const IS_POST_DATE_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_DATE_ENABLED_MOBILE}`;
export const IS_COVER_IMAGE_ENABLED_MOBILE = 'blog-mobile-isCoverImageEnabled';
export const IS_COVER_IMAGE_ENABLED_MOBILE_PATH = `style.booleans.${IS_COVER_IMAGE_ENABLED_MOBILE}`;
export const IS_POST_UPDATED_DATE_ENABLED_MOBILE = 'blog-mobile-isPostUpdatedDateEnabled';
export const IS_POST_UPDATED_DATE_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_UPDATED_DATE_ENABLED_MOBILE}`;
export const IS_RECENT_POSTS_ENABLED_MOBILE = 'blog-mobile-isRecentPostsEnabled';
export const IS_RECENT_POSTS_ENABLED_MOBILE_PATH = `style.booleans.${IS_RECENT_POSTS_ENABLED_MOBILE}`;
export const IS_COMMENTS_ENABLED_MOBILE = 'blog-mobile-isCommentsEnabled';
export const IS_COMMENTS_ENABLED_MOBILE_PATH = `style.booleans.${IS_COMMENTS_ENABLED_MOBILE}`;
export const IS_CATEGORY_LABELS_ENABLED_MOBILE = 'blog-mobile-isCategoryLabelsEnabled';
export const IS_CATEGORY_LABELS_ENABLED_MOBILE_PATH = `style.booleans.${IS_CATEGORY_LABELS_ENABLED_MOBILE}`;
export const IS_POST_TITLE_ENABLED_MOBILE = 'blog-mobile-isPostTitleEnabled';
export const IS_POST_TITLE_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_TITLE_ENABLED_MOBILE}`;
export const IS_POST_PUBLISH_DATE_ENABLED_MOBILE = 'blog-mobile-isPostPublishDateEnabled';
export const IS_POST_PUBLISH_DATE_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_PUBLISH_DATE_ENABLED_MOBILE}`;
export const IS_READING_TIME_ENABLED_MOBILE = 'blog-mobile-isReadingTimeEnabled';
export const IS_READING_TIME_ENABLED_MOBILE_PATH = `style.booleans.${IS_READING_TIME_ENABLED_MOBILE}`;
export const IS_POST_DESCRIPTION_ENABLED_MOBILE = 'blog-mobile-isPostDescriptionEnabled';
export const IS_POST_DESCRIPTION_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_DESCRIPTION_ENABLED_MOBILE}`;
export const IS_BLOG_MENU_ENABLED_MOBILE = 'blogMenu-mobile-isEnabled';
export const IS_BLOG_MENU_ENABLED_MOBILE_PATH = `style.booleans.${IS_BLOG_MENU_ENABLED_MOBILE}`;
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_MOBILE = 'blogMenu-mobile-isCategoryLabelsEnabled';
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_MOBILE_PATH = `style.booleans.${IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_MOBILE}`;
export const IS_BLOG_MENU_SEARCH_ENABLED_MOBILE = 'blogMenu-mobile-isSearchEnabled';
export const IS_BLOG_MENU_SEARCH_ENABLED_MOBILE_PATH = `style.booleans.${IS_BLOG_MENU_SEARCH_ENABLED_MOBILE}`;
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_MOBILE = 'blogMenu-mobile-isLoginButtonEnabled';
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_MOBILE_PATH = `style.booleans.${IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_MOBILE}`;
export const IS_SOCIAL_SHARING_ENABLED_MOBILE = 'socialSharing-mobile-isEnabled';
export const IS_SOCIAL_SHARING_ENABLED_MOBILE_PATH = `style.booleans.${IS_SOCIAL_SHARING_ENABLED_MOBILE}`;
export const IS_PINTEREST_ENABLED = 'pinterest-isEnabled';
export const IS_PINTEREST_ENABLED_PATH = `style.booleans.${IS_PINTEREST_ENABLED}`;
export const IS_TWITTER_ENABLED = 'twitter-isEnabled';
export const IS_TWITTER_ENABLED_PATH = `style.booleans.${IS_TWITTER_ENABLED}`;
// Feed metadata display settings
export const IS_VIEW_COUNT_ENABLED = 'blog-isViewCountEnabled';
export const IS_VIEW_COUNT_ENABLED_PATH = `style.booleans.${IS_VIEW_COUNT_ENABLED}`;
export const IS_COMMENT_COUNT_ENABLED = 'blog-isCommentCountEnabled';
export const IS_COMMENT_COUNT_ENABLED_PATH = `style.booleans.${IS_COMMENT_COUNT_ENABLED}`;
export const IS_LIKE_COUNT_ENABLED = 'blog-isLikeCountEnabled';
export const IS_LIKE_COUNT_ENABLED_PATH = `style.booleans.${IS_LIKE_COUNT_ENABLED}`;
export const IS_AUTHOR_NAME_ENABLED = 'blog-isAuthorNameEnabled';
export const IS_AUTHOR_NAME_ENABLED_PATH = `style.booleans.${IS_AUTHOR_NAME_ENABLED}`;
export const IS_AUTHOR_PICTURE_ENABLED = 'blog-isAuthorPictureEnabled';
export const IS_AUTHOR_PICTURE_ENABLED_PATH = `style.booleans.${IS_AUTHOR_PICTURE_ENABLED}`;
export const IS_AUTHOR_BADGE_ENABLED = 'blog-isAuthorBadgeEnabled';
export const IS_AUTHOR_BADGE_ENABLED_PATH = `style.booleans.${IS_AUTHOR_BADGE_ENABLED}`;
export const AUTHOR_INFO_TYPE = 'blog-authorInfoType';
export const AUTHOR_INFO_TYPE_PATH = `style.numbers.${AUTHOR_INFO_TYPE}`;
export const AUTHOR_INFO_TYPE_NAME_PICTURE = 0;
export const AUTHOR_INFO_TYPE_NAME = 1;
export const IS_POST_DATE_ENABLED = 'blog-isPostDateEnabled';
export const IS_POST_DATE_ENABLED_PATH = `style.booleans.${IS_POST_DATE_ENABLED}`;
export const IS_POST_UPDATED_DATE_ENABLED = 'blog-isPostUpdatedDateEnabled';
export const IS_POST_UPDATED_DATE_ENABLED_PATH = `style.booleans.${IS_POST_UPDATED_DATE_ENABLED}`;
export const IS_RECENT_POSTS_ENABLED = 'blog-isRecentPostsEnabled';
export const IS_RECENT_POSTS_ENABLED_PATH = `style.booleans.${IS_RECENT_POSTS_ENABLED}`;
export const IS_COMMENTS_ENABLED = 'blog-isCommentsEnabled';
export const IS_COMMENTS_ENABLED_PATH = `style.booleans.${IS_COMMENTS_ENABLED}`;
export const IS_ANONYMOUS_COMMENTS_ENABLED = 'blog-isAnonymousCommentsEnabled';
export const IS_ANONYMOUS_COMMENTS_ENABLED_PATH = `style.booleans.${IS_ANONYMOUS_COMMENTS_ENABLED}`;
export const IS_CATEGORY_LABELS_ENABLED = 'blog-isCategoryLabelsEnabled';
export const IS_CATEGORY_LABELS_ENABLED_PATH = `style.booleans.${IS_CATEGORY_LABELS_ENABLED}`;
export const IS_TAGS_ENABLED = 'blog-isTagsEnabled';
export const IS_TAGS_ENABLED_PATH = `style.booleans.${IS_TAGS_ENABLED}`;
export const IS_TAGS_ENABLED_MOBILE = 'blog-mobile-isTagsEnabled';
export const IS_TAGS_ENABLED_MOBILE_PATH = `style.booleans.${IS_TAGS_ENABLED_MOBILE}`;
export const IS_POST_TITLE_ENABLED = 'blog-isPostTitleEnabled';
export const IS_POST_TITLE_ENABLED_PATH = `style.booleans.${IS_POST_TITLE_ENABLED}`;
export const IS_POST_PUBLISH_DATE_ENABLED = 'blog-isPostPublishDateEnabled';
export const IS_POST_PUBLISH_DATE_ENABLED_PATH = `style.booleans.${IS_POST_PUBLISH_DATE_ENABLED}`;
export const IS_READING_TIME_ENABLED = 'blog-isReadingTimeEnabled';
export const IS_READING_TIME_ENABLED_PATH = `style.booleans.${IS_READING_TIME_ENABLED}`;
export const IS_MORE_OPTIONS_MENU_ENABLED = 'blog-isMoreOptionsMenuEnabled';
export const IS_MORE_OPTIONS_MENU_ENABLED_PATH = `style.booleans.${IS_MORE_OPTIONS_MENU_ENABLED}`;
export const IS_POST_DESCRIPTION_ENABLED = 'blog-isPostDescriptionEnabled';
export const IS_POST_DESCRIPTION_ENABLED_PATH = `style.booleans.${IS_POST_DESCRIPTION_ENABLED}`;
export const IS_COVER_IMAGE_ENABLED = 'blog-isCoverImageEnabled';
export const IS_COVER_IMAGE_ENABLED_PATH = `style.booleans.${IS_COVER_IMAGE_ENABLED}`;
export const IS_CATEGORY_LABEL_ENABLED = 'blog-isCategoryLabelEnabled';
export const IS_CATEGORY_LABEL_ENABLED_PATH = `style.booleans.${IS_CATEGORY_LABEL_ENABLED}`;
export const IS_CATEGORY_LABEL_ENABLED_MOBILE = 'blog-mobile-isCategoryLabelEnabled';
export const IS_CATEGORY_LABEL_ENABLED_MOBILE_PATH = `style.booleans.${IS_CATEGORY_LABEL_ENABLED_MOBILE}`;
export const IS_POST_RATING_ENABLED = 'blog-isPostRatingEnabled';
export const IS_POST_RATING_ENABLED_PATH = `style.booleans.${IS_POST_RATING_ENABLED}`;
export const IS_POST_RATING_ENABLED_MOBILE = 'blog-mobile-isPostRatingEnabled';
export const IS_POST_RATING_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_RATING_ENABLED_MOBILE}`;
// Full widith
export const IS_POST_LIST_FULL_WIDTH_ENABLED = 'blog-isPostListFullWidthEnabled';
export const IS_POST_LIST_FULL_WIDTH_ENABLED_PATH = `style.booleans.${IS_POST_LIST_FULL_WIDTH_ENABLED}`;
// Layout params
export const IS_MOBILE_LAYOUT_SETTINGS_ENABLED = 'blog-mobile-isMobileLayoutSettingsEnabled';
export const IS_MOBILE_LAYOUT_SETTINGS_ENABLED_PATH = `style.booleans.${IS_MOBILE_LAYOUT_SETTINGS_ENABLED}`;
export const IS_POST_DESIGN_IN_FULL_POST_ENABLED = 'blog-postDesignInFullpostEnabled';
export const IS_POST_DESIGN_IN_FULL_POST_ENABLED_PATH = `style.booleans.${IS_POST_DESIGN_IN_FULL_POST_ENABLED}`;
const getLayoutParam = (section, param, isMobile) => `layout-${isMobile ? 'mobile-' : ''}${section}-${param}`;
export const getLayoutType = (section, isMobile = false) => getLayoutParam(section, 'layoutType', isMobile);
export const getLayoutTypePath = (section, isMobile = false) => `style.numbers.${getLayoutType(section, isMobile)}`;
function getPGLayoutParam(param) {
    function getter(section, layoutName, isMobile = false) {
        return `layout-${isMobile ? 'mobile-' : ''}${section}-${layoutName}-${param}`;
    }
    return getter;
}
const getPGLayoutParamPath = (getLayoutParamFn) => (section, layoutName, isMobile = false) => `style.numbers.${getLayoutParamFn(section, layoutName, isMobile)}`;
export const getLayoutSpacingParam = getPGLayoutParam('layoutSpacing');
export const getLayoutPostSizeParam = getPGLayoutParam('layoutPostSize');
export const getLayoutCardsRowTypeParam = getPGLayoutParam('layoutCardsRowType');
export const getLayoutPostsPerRowParam = getPGLayoutParam('layoutPostsPerRow');
export const getLayoutContentHeightParam = getPGLayoutParam('contentHeight');
export const getLayoutContentHeightTypeParam = getPGLayoutParam('contentHeightType');
export const getLayoutMarginsParam = getPGLayoutParam('margins');
export const getLayoutTitleLineCountParam = getPGLayoutParam('titleLineCount');
export const getLayoutDescriptionLineCountParam = getPGLayoutParam('descriptionLineCount');
export const getLayoutSidesPaddingParam = getPGLayoutParam('sidesPadding');
export const getLayoutImageRatioParam = getPGLayoutParam('imageRatio');
export const getLayoutImageAlignmentParam = getPGLayoutParam('imageAlignment');
export const getLayoutImageProportionsParam = getPGLayoutParam('imageProportions');
export const getLayoutImageCropTypeParam = getPGLayoutParam('imageCropType');
export const getLayoutImageResizingModeParam = getPGLayoutParam('imageResizingMode');
export const getLayoutImageWidthParam = getPGLayoutParam('imageWidth');
export const getLayoutSpacingParamPath = getPGLayoutParamPath(getLayoutSpacingParam);
export const getLayoutPostSizeParamPath = getPGLayoutParamPath(getLayoutPostSizeParam);
export const getLayoutCardsRowTypeParamPath = getPGLayoutParamPath(getLayoutCardsRowTypeParam);
export const getLayoutPostsPerRowParamPath = getPGLayoutParamPath(getLayoutPostsPerRowParam);
export const getLayoutImageRatioParamPath = getPGLayoutParamPath(getLayoutImageRatioParam);
export const getLayoutContentHeightParamPath = getPGLayoutParamPath(getLayoutContentHeightParam);
export const getLayoutContentHeightTypeParamPath = getPGLayoutParamPath(getLayoutContentHeightTypeParam);
export const getLayoutMarginsParamPath = getPGLayoutParamPath(getLayoutMarginsParam);
export const getLayoutTitleLineCountParamPath = getPGLayoutParamPath(getLayoutTitleLineCountParam);
export const getLayoutDescriptionLineCountParamPath = getPGLayoutParamPath(getLayoutDescriptionLineCountParam);
export const getLayoutSidesPaddingParamPath = getPGLayoutParamPath(getLayoutSidesPaddingParam);
export const getLayoutImageAlignmentParamPath = getPGLayoutParamPath(getLayoutImageAlignmentParam);
export const getLayoutImageProportionsParamPath = getPGLayoutParamPath(getLayoutImageProportionsParam);
export const getLayoutImageCropTypeParamPath = getPGLayoutParamPath(getLayoutImageCropTypeParam);
export const getLayoutImageResizingModeParamPath = getPGLayoutParamPath(getLayoutImageResizingModeParam);
export const getLayoutImageWidthParamPath = getPGLayoutParamPath(getLayoutImageWidthParam);
const getPaginationParam = (section, param) => `pagination-${section}-${param}`;
export const getPaginationPageSize = (section) => getPaginationParam(section, 'pageSize');
export const getPaginationPageSizePath = (section) => `style.numbers.${getPaginationPageSize(section)}`;
export const getPaginationType = (section) => getPaginationParam(section, 'type');
export const getPaginationTypePath = (section) => `style.numbers.${getPaginationType(section)}`;
export const getSBSLayoutImagePositionParam = (section) => `blog-sideBySideLayoutImagePosition-${section}`;
export const getSBSLayoutImagePositionParamPath = (section) => `style.numbers.${getSBSLayoutImagePositionParam(section)}`;
// Post design params
export const IS_MOBILE_DESIGN_SETTINGS_ENABLED = 'blog-mobile-isMobileDesignSettingsEnabled';
export const IS_MOBILE_DESIGN_SETTINGS_ENABLED_PATH = `style.booleans.${IS_MOBILE_DESIGN_SETTINGS_ENABLED}`;
export const TITLE_FONT_SIZE = 'titleFontSize';
export const DESCRIPTION_FONT_SIZE = 'descriptionFontSize';
export const IS_FEED_DESIGN_PROPS_MIGRATED = 'blog-isFeedDesignPropsMigrated';
export const IS_FEED_DESIGN_PROPS_MIGRATED_PATH = `style.booleans.${IS_FEED_DESIGN_PROPS_MIGRATED}`;
export const IS_CONFIGURABLE_LINE_CLAMPING_ENABLED = 'blog-isConfigurableLineClampingEnabled';
export const IS_CONFIGURABLE_LINE_CLAMPING_ENABLED_PATH = `style.booleans.${IS_CONFIGURABLE_LINE_CLAMPING_ENABLED}`;
export const POST_TITLE_COLOR = 'post-titleColor';
export const POST_TEXT_COLOR = 'post-textColor';
export const POST_TEXT_COLOR_PATH = `style.colors.${POST_TEXT_COLOR}`;
export const POST_TITLE_FONT = 'post-titleFont';
export const POST_TITLE_FONT_PATH = `style.fonts.${POST_TITLE_FONT}`;
export const POST_DESCRIPTION_FONT = 'post-descriptionFont';
export const POST_PAGE_FONT = 'post-pageFont';
export const POST_PAGE_FONT_PATH = `style.fonts.${POST_PAGE_FONT}`;
export const POST_TITLE_FONT_SIZE_MOBILE = `post-mobile-${TITLE_FONT_SIZE}`;
export const POST_TITLE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_TITLE_FONT_SIZE_MOBILE}`;
export const POST_PAGE_FONT_SIZE_MOBILE = 'post-mobile-pageFontSize';
export const POST_PAGE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_PAGE_FONT_SIZE_MOBILE}`;
export const getPostLayoutParamByName = (...params) => `post-${params.filter(identity).join('-')}`;
export const getPostLayoutParamByType = (layoutType, section, param, isMobile = false) => getPostLayoutParamByName(getLayoutName(layoutType), section, isMobile ? 'mobile' : '', param);
export const getPostTitleFontSize = (layout, section, isMobile) => getPostLayoutParamByType(layout, section, TITLE_FONT_SIZE, isMobile);
export const getPostDescriptionFontSize = (layout, section, isMobile) => getPostLayoutParamByType(layout, section, DESCRIPTION_FONT_SIZE, isMobile);
export const getPostMetadataFontSize = (layout, section) => getPostLayoutParamByType(layout, section, 'metadataFontSize');
export const getPostFontSizesPath = (...args) => `style.numbers.${getPostLayoutParamByType(...args)}`;
export const getGenericPostFontPath = (section, font) => `style.fonts.${getPostLayoutParamByName(section, font)}`;
export const getCardBorderWidth = (layout, section) => `post-${getLayoutName(layout)}-${section}-cardBorderWidth`;
export const getCardBorderWidthPath = (...args) => `style.numbers.${getCardBorderWidth(...args)}`;
export const getFeedBorderColor = (section) => `post-${section}-borderColor`;
export const getFeedBorderColorPath = (section) => `style.colors.${getFeedBorderColor(section)}`;
export const getMobileFeedBorderColor = (section) => `post-${section}-mobile-borderColor`;
export const getMobileFeedBorderColorPath = (section) => `style.colors.${getMobileFeedBorderColor(section)}`;
export const CARD_BACKGROUND_COLOR = 'post-cardBackgroundColor';
export const CARD_BACKGROUND_COLOR_PATH = `style.colors.${CARD_BACKGROUND_COLOR}`;
export const CARD_BORDER_COLOR = 'post-cardBorderColor';
export const CARD_BORDER_WIDTH = 'post-cardBorderWidth';
export const CARD_BORDER_WIDTH_PATH = `style.numbers.${CARD_BORDER_WIDTH}`;
export const APP_BACKGROUND_COLOR = 'post-appBackgroundColor';
export const APP_BACKGROUND_COLOR_PATH = `style.colors.${APP_BACKGROUND_COLOR}`;
export const NAVIGATION_BACKGROUND_COLOR = 'navigation-backgroundColor';
export const NAVIGATION_BACKGROUND_COLOR_PATH = `style.colors.${NAVIGATION_BACKGROUND_COLOR}`;
export const DEFAULT_NAVIGATION_BACKGROUND_COLOR = 'rgba(255,255,255,1)';
export const NAVIGATION_TEXT_COLOR = 'navigation-textColor';
export const NAVIGATION_TEXT_COLOR_PATH = `style.colors.${NAVIGATION_TEXT_COLOR}`;
export const NAVIGATION_TEXT_COLOR_ACTIVE = 'navigation-textColorActive';
export const NAVIGATION_TEXT_COLOR_ACTIVE_PATH = `style.colors.${NAVIGATION_TEXT_COLOR_ACTIVE}`;
const getRatingFontDefaultProps = (isToiLayout = false) => ({
    startWithColor: isToiLayout ? '#FFFFFF' : 'color-5',
    startWithTheme: 'font_8',
    fontMinSize: 12,
    fontMaxSize: 24,
    startWithSize: 14,
});
export const LAYOUT_SETTINGS_PROPS = {
    [LAYOUT_CARD_MEDIUM]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 26,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_SIDE_BY_SIDE]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_TEXT_ON_IMAGE_MEDIUM]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 26,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            hideSize: true,
            startWithSize: 16,
            startWithColor: '#FFFFFF',
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_GRID]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 22,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_CARD_SMALL]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 22,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_TEXT_ON_IMAGE_SMALL]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 28,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            startWithColor: '#FFFFFF',
            startWithSize: 16,
            hideSize: true,
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_CARD_LARGE]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_FULL_POST]: {
        titleFont: {
            fontMinSize: 28,
            fontMaxSize: 176,
            startWithSize: 40,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            startWithColor: 'color-5',
            fontMinSize: 14,
            fontMaxSize: 176,
            startWithSize: 18,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_ONE_COLUMN_MOBILE]: {
        titleFont: {
            fontMinSize: 12,
            fontMaxSize: 30,
            startWithSize: 22,
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 18,
            startWithSize: 14,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_SIDE_BY_SIDE_MOBILE]: {
        titleFont: {
            fontMinSize: 12,
            fontMaxSize: 30,
            startWithSize: 14,
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 18,
            startWithSize: 14,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_TEXT_ON_IMAGE_MOBILE]: {
        titleFont: {
            fontMinSize: 12,
            fontMaxSize: 30,
            startWithSize: 22,
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 18,
            startWithSize: 16,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_TEXT_ON_IMAGE_SMALL]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            hideSize: true,
            startWithSize: 16,
            startWithColor: '#FFFFFF',
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 26,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            hideSize: true,
            startWithSize: 16,
            startWithColor: '#FFFFFF',
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_PG_TEXT_ON_IMAGE_LARGE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 28,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            hideSize: true,
            startWithSize: 16,
            startWithColor: '#FFFFFF',
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_PG_CARD_MEDIUM]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 26,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_SIDE_BY_SIDE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_SIDE_BY_SIDE_RIGHT]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_GRID]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_GRID_INTERMEDIATE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_GRID_LARGE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_ONE_COLUMN]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 176,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_LIST]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 14,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 14,
            startWithColor: 'color-5',
            hideSize: true,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_LIST_MEDIUM]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 18,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 14,
            startWithColor: 'color-5',
            hideSize: true,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_LIST_LARGE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 14,
            startWithColor: 'color-5',
            hideSize: true,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_SLIDER]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
};
const LAYOUT_SETTINGS_PROPS_MY_POSTS = {
    [LAYOUT_PG_SIDE_BY_SIDE]: {
        titleFont: {
            hideTheme: false,
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            hideSize: true,
            hideTheme: false,
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
};
export const getLayoutSettingsProps = (layoutType, section) => {
    const settingsByLayoutType = section === SECTION_MY_POSTS
        ? LAYOUT_SETTINGS_PROPS_MY_POSTS
        : LAYOUT_SETTINGS_PROPS;
    return settingsByLayoutType[layoutType];
};
export const getLayoutDefaultFontSize = (layoutType, section, contentType) => {
    const layoutSettingsProps = getLayoutSettingsProps(layoutType, section);
    return get(layoutSettingsProps, `${contentType}.startWithSize`);
};
export const LAYOUT_DEFAULT_FONT_FAMILY = 'open sans';
export const LAYOUT_DEFAULT_CSS_FONT_FAMILY = '"open sans", sans-serif';
export const LAYOUT_DEFAULT_FONT = {
    displayName: 'Paragraph 2',
    editorKey: 'font_2',
    family: LAYOUT_DEFAULT_FONT_FAMILY,
    fontStyleParam: true,
    preset: 'Custom',
    size: 15,
    style: {
        bold: false,
        italic: false,
        underline: false,
    },
    value: `font:normal normal normal 15px/21px ${LAYOUT_DEFAULT_CSS_FONT_FAMILY}`,
};
// Post advanced design options
export const POST_HEADER_TWO_FONT = 'post-headerTwoFont';
export const POST_HEADER_TWO_COLOR = 'post-headerTwoColor';
export const POST_HEADER_THREE_FONT = 'post-headerThreeFont';
export const POST_HEADER_THREE_COLOR = 'post-headerThreeColor';
export const POST_HEADER_FOUR_FONT = 'post-headerFourFont';
export const POST_HEADER_FOUR_COLOR = 'post-headerFourColor';
export const POST_HEADER_FIVE_FONT = 'post-headerFiveFont';
export const POST_HEADER_FIVE_COLOR = 'post-headerFiveColor';
export const POST_HEADER_SIX_FONT = 'post-headerSixFont';
export const POST_HEADER_SIX_COLOR = 'post-headerSixColor';
export const POST_QUOTES_FONT = 'post-quotesFont';
export const POST_QUOTES_COLOR = 'post-quotesColor';
export const POST_HEADER_TWO_FONT_SIZE_MOBILE = 'post-mobile-headerTwoFontSize';
export const POST_HEADER_TWO_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_TWO_FONT_SIZE_MOBILE}`;
export const POST_HEADER_THREE_FONT_SIZE_MOBILE = 'post-mobile-headerThreeFontSize';
export const POST_HEADER_THREE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_THREE_FONT_SIZE_MOBILE}`;
export const POST_HEADER_FOUR_FONT_SIZE_MOBILE = 'post-mobile-headerFourFontSize';
export const POST_HEADER_FOUR_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_FOUR_FONT_SIZE_MOBILE}`;
export const POST_HEADER_FIVE_FONT_SIZE_MOBILE = 'post-mobile-headerFiveFontSize';
export const POST_HEADER_FIVE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_FIVE_FONT_SIZE_MOBILE}`;
export const POST_HEADER_SIX_FONT_SIZE_MOBILE = 'post-mobile-headerSixFontSize';
export const POST_HEADER_SIX_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_HEADER_SIX_FONT_SIZE_MOBILE}`;
export const POST_QUOTES_FONT_SIZE_MOBILE = 'post-mobile-quotesFontSize';
export const POST_QUOTES_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_QUOTES_FONT_SIZE_MOBILE}`;
export const IS_POST_ADVANCED_DESIGN_OPTIONS_ENABLED = 'post-isAdvancedDesignOptionsEnabled';
export const IS_POST_ADVANCED_DESIGN_OPTIONS_ENABLED_PATH = `style.booleans.${IS_POST_ADVANCED_DESIGN_OPTIONS_ENABLED}`;
export const POST_RATING_FILLED_STAR_COLOR = 'post-ratingFilledStarColor';
export const POST_RATING_UNFILLED_STAR_COLOR = 'post-ratingUnfilledStarColor';
export const POST_RATING_FONT = 'post-ratingFont';
export const POST_RATING_FONT_COLOR = 'post-ratingFontColor';
// Button design params
export const BUTTON_COLOR = 'button-color';
export const BUTTON_COLOR_PATH = `style.colors.${BUTTON_COLOR}`;
export const BUTTON_TEXT_COLOR = 'button-textColor';
export const SECONDARY_ICON_COLOR = 'icon-secondaryColor';
export const SECONDARY_ICON_COLOR_PATH = `style.colors.${SECONDARY_ICON_COLOR}`;
// Link and hashtag params
export const LINK_AND_HASHTAG_COLOR = 'blog-linkHashtagColor';
export const POST_HOMEPAGE_LINK_AND_HASHTAG_COLOR = 'post-homepage-linkHashtagColor';
// Widget params
export const WIDGET_SIGN_UP_BUTTON_TYPE = 'widget-signUpButtonType';
export const WIDGET_SIGN_UP_BUTTON_TYPE_PATH = `style.numbers.${WIDGET_SIGN_UP_BUTTON_TYPE}`;
export const WIDGET_SIGN_UP_BUTTON_BORDER_COLOR = 'widget-signUpButtonBorderColor';
export const WIDGET_SIGN_UP_BUTTON_BORDER_COLOR_PATH = `style.colors.${WIDGET_SIGN_UP_BUTTON_BORDER_COLOR}`;
export const WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR = 'widget-signUpButtonBackgroundColor';
export const WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR_PATH = `style.colors.${WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR}`;
export const WIDGET_SIGN_UP_BUTTON_FONT = 'widget-signUpButtonFont';
export const WIDGET_SIGN_UP_BUTTON_FONT_PATH = `style.fonts.${WIDGET_SIGN_UP_BUTTON_FONT}`;
export const WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR = 'widget-signUpButtonPrimaryColor';
export const WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR_PATH = `style.fonts.${WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR}`;
export const WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR = 'widget-signUpButtonSecondaryColor';
export const WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR_PATH = `style.fonts.${WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR}`;
export const WIDGET_NOTIFICATION_ICON_COLOR = 'widget-notificationIconColor';
export const WIDGET_NOTIFICATION_ICON_COLOR_PATH = `style.colors.${WIDGET_NOTIFICATION_ICON_COLOR}`;
export const WIDGET_NOTIFICATION_BUBBLE_COLOR = 'widget-notificationBubbleColor';
export const WIDGET_NOTIFICATION_BUBBLE_COLOR_PATH = `style.colors.${WIDGET_NOTIFICATION_BUBBLE_COLOR}`;
export const WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR = 'widget-notificationBubbleTextColor';
export const WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR_PATH = `style.colors.${WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR}`;
export const WIDGET_AVATAR_BORDER_COLOR = 'widget-avatarBorderColor';
export const WIDGET_AVATAR_BORDER_COLOR_PATH = `style.colors.${WIDGET_AVATAR_BORDER_COLOR}`;
// Blog menu
export const IS_BLOG_MENU_ENABLED = 'blogMenu-isEnabled';
export const IS_BLOG_MENU_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_ENABLED}`;
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED = 'blogMenu-isCategoryLabelsEnabled';
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_CATEGORY_LABELS_ENABLED}`;
export const IS_BLOG_MENU_SEARCH_ENABLED = 'blogMenu-isSearchEnabled';
export const IS_BLOG_MENU_SEARCH_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_SEARCH_ENABLED}`;
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED = 'widget-isLoginButtonEnabled';
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_LOGIN_BUTTON_ENABLED}`;
// Social sharing
export const IS_SOCIAL_SHARING_ENABLED = 'socialSharing-isEnabled';
export const IS_SOCIAL_SHARING_ENABLED_PATH = `style.booleans.${IS_SOCIAL_SHARING_ENABLED}`;
export const getIsSocialSharingProviderEnabledParam = (provider, isMobile = false) => `socialSharing-${isMobile ? 'mobile-' : ''}${provider}`;
export const getIsSocialSharingProviderEnabledParamPath = (provider, isMobile = false) => `style.booleans.${getIsSocialSharingProviderEnabledParam(provider, isMobile)}`;
// Category header params
export const IS_CATEGORY_HEADER_ENABLED = 'categoryHeader-isEnabled';
export const IS_CATEGORY_HEADER_ENABLED_PATH = `style.booleans.${IS_CATEGORY_HEADER_ENABLED}`;
// Banner params
export const IS_BANNER_ENABLED = 'banner-isEnabled';
export const IS_BANNER_ENABLED_PATH = `style.booleans.${IS_BANNER_ENABLED}`;
// Pagination
const getPaginationParamPath = (section, param) => `pagination-${section}-${param}`;
export const getPaginationTypeParam = (section = SECTION_HOMEPAGE) => getPaginationParamPath(section, 'type');
export const getPaginationTypeParamPath = (section = SECTION_HOMEPAGE) => `style.numbers.${getPaginationTypeParam(section)}`;
export const getPaginationPageSizeParam = (section = SECTION_HOMEPAGE) => getPaginationParamPath(section, 'pageSize');
export const getPaginationPageSizeParamPath = (section = SECTION_HOMEPAGE) => `style.numbers.${getPaginationPageSizeParam(section)}`;
//# sourceMappingURL=wix-params.js.map